import React from 'react';
import { FiSend } from 'react-icons/fi';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomRouter from 'src/hooks/useCustomRouter';
import useCustomToast from 'src/hooks/useCustomToast';
import { URL_RETORNO } from 'src/parametros';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { POST, guardarLead } from 'src/services';
import { urlEnviarCorreoClientePago } from 'src/services/urls';
import { Layout } from '../styleds';

const NotificarClienteP2p = () => {
  const { cotizacion, idCotizacion } = useCotizacion();
  const { addSuccessToast, addWarningToast } = useCustomToast();

  const { valdiarTerminos, setLoading, resetLoading } = usePaginaPago();

  const router = useCustomRouter();

  const notificarClientePtp = async () => {
    guardarLead(idCotizacion, 'PAGINA_PAGO__SELECCIONO_PAGO_NOTIFICAR_CLIENTE');

    setLoading({
      loading: true,
      principal: 'Estamos enviando el enlace de pago',
      secundario: 'Espere por favor',
    });

    const DataEnviarCorreoCliente = {
      idCotizacion: idCotizacion,
      urlRedirect: `${URL_RETORNO}place-to-pay/${idCotizacion}`,
      empCodigo: cotizacion?.producto?.empCodigo,
    };

    const res = await POST(urlEnviarCorreoClientePago, DataEnviarCorreoCliente);

    if (res.transaccion && !res.error) {
      addSuccessToast(`SE HA ENVIADO UN CORREO A ${cotizacion.titular.email}`);
      router.push(`/newFinCompra/${idCotizacion}?envioCorreoCliente=true`);
    } else {
      addWarningToast(
        'HA OCURRIDO UN PROBLEMA AL ENVIAR EL CORREO, POR FAVOR INTENTAR NUEVAMENTE.',
      );
    }
    resetLoading();
  };

  return (
    <Layout onClick={valdiarTerminos(notificarClientePtp)}>
      <div className="d-flex flex-row text-primary">
        <FiSend className="mr-1 mt-0" size="25" /> <h4>Enviar enlace</h4>
      </div>
    </Layout>
  );
};

export default NotificarClienteP2p;
